// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.id-txt {
    color: rgb(116, 114, 114);
}

.id-cticons svg {
    color: rgb(116, 114, 114);
}

.b-cont {
    border-radius: 50px;
}

.h-cont {
    border: #81D3D5 2px solid;
    border-radius: 25px;


}

.h-d {
    background: rgb(131, 58, 180);
    background: linear-gradient(90deg, rgba(131, 58, 180, 1) 0%, rgba(66, 191, 255, 1) 100%);
    border-radius: 25px 25px 0px 0px;
    width: 100%;
    padding: 0;
    margin: 0;


}

.h-d-title {
    font-size: 22px;
    color: white;
    font-style: bold;
}


button.btn-g {
    background: #7A6BE2;
    width: 100%;
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    border-color: transparent !important;
    border-radius: 15px;
    color: white;
    box-shadow: 8px 7px 8px -4px rgba(56,54,54,0.75);
-webkit-box-shadow: 8px 7px 8px -4px rgba(56,54,54,0.75);
-moz-box-shadow: 8px 7px 8px -4px rgba(56,54,54,0.75);
}
.btn-g:hover{
    background: #8272e7;
}
.btn-g-txt {
    font-size: 25px;
}

.btn-g:focus {
    outline: none;
    box-shadow: none;
}

.cursor-pointer{
    cursor: pointer;
}


.content-denuncia select,
.content-denuncia textarea,
.content-denuncia input.form-control
textarea.form-control ,
.content-denuncia select.form-control {

    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    border-color: #444258 !important;
    border-radius:15px !important;
}

.input-p{
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    border-color: #444258 !important;
    border-radius:15px !important;
}


.d-f{
    border: 1px solid #444258 !important;
    border-radius:15px !important;
}

input:focus,
select:focus,
select,
input.form-control:focus,
textarea.form-control:focus ,
select.form-control:focus {

    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    border-color: #444258 !important;
}

input.form-check-input {
    border-radius: none !important;
    border: 2px solid;
    border-color: #42BFFF !important;
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
}

input.form-check-input:focus {
    border-color: #42BFFF !important;
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
}

input.form-check-input:checked {
    background-color: #8bd3f7;
}

/* textarea:focus, input:focus, input[type]:focus {

    border-color: rgb(78, 37, 78);

    box-shadow: 0 1px 1px rgba(229, 103, 23, 0.075)inset, 0 0 8px rgba(255,144,0,0.6);

    outline: 0 none;

} */`, "",{"version":3,"sources":["webpack://./src/Views/Employee/ingresod.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;;;AAGvB;;AAEA;IACI,6BAA6B;IAC7B,wFAAwF;IACxF,gCAAgC;IAChC,WAAW;IACX,UAAU;IACV,SAAS;;;AAGb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,gDAAgD;AACpD,wDAAwD;AACxD,qDAAqD;AACrD;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA;;;;;;IAMI,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;AACjC;;;AAGA;IACI,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;;;;;;;IAOI,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gCAAgC;IAChC,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;;;GAQG","sourcesContent":[".id-txt {\r\n    color: rgb(116, 114, 114);\r\n}\r\n\r\n.id-cticons svg {\r\n    color: rgb(116, 114, 114);\r\n}\r\n\r\n.b-cont {\r\n    border-radius: 50px;\r\n}\r\n\r\n.h-cont {\r\n    border: #81D3D5 2px solid;\r\n    border-radius: 25px;\r\n\r\n\r\n}\r\n\r\n.h-d {\r\n    background: rgb(131, 58, 180);\r\n    background: linear-gradient(90deg, rgba(131, 58, 180, 1) 0%, rgba(66, 191, 255, 1) 100%);\r\n    border-radius: 25px 25px 0px 0px;\r\n    width: 100%;\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n\r\n}\r\n\r\n.h-d-title {\r\n    font-size: 22px;\r\n    color: white;\r\n    font-style: bold;\r\n}\r\n\r\n\r\nbutton.btn-g {\r\n    background: #7A6BE2;\r\n    width: 100%;\r\n    outline: none !important;\r\n    outline-width: 0 !important;\r\n    box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n    border-color: transparent !important;\r\n    border-radius: 15px;\r\n    color: white;\r\n    box-shadow: 8px 7px 8px -4px rgba(56,54,54,0.75);\r\n-webkit-box-shadow: 8px 7px 8px -4px rgba(56,54,54,0.75);\r\n-moz-box-shadow: 8px 7px 8px -4px rgba(56,54,54,0.75);\r\n}\r\n.btn-g:hover{\r\n    background: #8272e7;\r\n}\r\n.btn-g-txt {\r\n    font-size: 25px;\r\n}\r\n\r\n.btn-g:focus {\r\n    outline: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.cursor-pointer{\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.content-denuncia select,\r\n.content-denuncia textarea,\r\n.content-denuncia input.form-control\r\ntextarea.form-control ,\r\n.content-denuncia select.form-control {\r\n\r\n    outline: none !important;\r\n    outline-width: 0 !important;\r\n    box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n    border-color: #444258 !important;\r\n    border-radius:15px !important;\r\n}\r\n\r\n.input-p{\r\n    outline: none !important;\r\n    outline-width: 0 !important;\r\n    box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n    border-color: #444258 !important;\r\n    border-radius:15px !important;\r\n}\r\n\r\n\r\n.d-f{\r\n    border: 1px solid #444258 !important;\r\n    border-radius:15px !important;\r\n}\r\n\r\ninput:focus,\r\nselect:focus,\r\nselect,\r\ninput.form-control:focus,\r\ntextarea.form-control:focus ,\r\nselect.form-control:focus {\r\n\r\n    outline: none !important;\r\n    outline-width: 0 !important;\r\n    box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n    border-color: #444258 !important;\r\n}\r\n\r\ninput.form-check-input {\r\n    border-radius: none !important;\r\n    border: 2px solid;\r\n    border-color: #42BFFF !important;\r\n    outline: none !important;\r\n    outline-width: 0 !important;\r\n    box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n}\r\n\r\ninput.form-check-input:focus {\r\n    border-color: #42BFFF !important;\r\n    outline: none !important;\r\n    outline-width: 0 !important;\r\n    box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n}\r\n\r\ninput.form-check-input:checked {\r\n    background-color: #8bd3f7;\r\n}\r\n\r\n/* textarea:focus, input:focus, input[type]:focus {\r\n\r\n    border-color: rgb(78, 37, 78);\r\n\r\n    box-shadow: 0 1px 1px rgba(229, 103, 23, 0.075)inset, 0 0 8px rgba(255,144,0,0.6);\r\n\r\n    outline: 0 none;\r\n\r\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
